import {
  Box,
  Button,
  Drawer,
  Tab,
  Tabs,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";
import VehicleListings from "../../features/manageVehicles/vehicleListings";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ListingFilters from "../../features/manageVehicles/listingFilters";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const tabTypes = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment"];

const ManageVehicles = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <>
      <div className="main_title">
        <h1>Listed Vehicles</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Listed Vehicles
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              {tabTypes.map((label, index) => (
                <Tab key={label} label={label} {...a11yProps(index)} />
              ))}
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Vehicles..."
            />

            <Button className="btn btn_primary br" onClick={toggleDrawer(true)}><FilterAltIcon /> Filters</Button>
            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)} >
              <ListingFilters
                type={tabTypes[valueTabs]}
                onClose={toggleDrawer(false)}
              />
            </Drawer>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-vehicles/add")}
            >
              <AddIcon /> Add Vehicle
            </Button>
          </div>
        </div>

        {tabTypes.map((type, tabIndex) => (
          <CustomTabPanel key={type} value={valueTabs} index={tabIndex}>
            <VehicleListings type={type} searchTerm={searchTerm} featured={false} />
          </CustomTabPanel>
        ))}
      </div>
    </>
  );
};

export default ManageVehicles;